import { createSelector } from 'reselect';
import { Army, ArmyListSize, Folder, Nullable } from '@Models';
import { ArmyListState } from '@Stores/index';
import { AppState } from '@Redux/store';
import { ArmyListView, ArmyView, FolderView } from './ArmyListView';

const getArmyList = (state: AppState): ArmyListState => state.armyList;

const getFolder = (state: AppState): Nullable<Folder> =>
  state.folders.entity?.find(
    (folder) => folder.id === state.armyList.entity?.folderId,
  ) ?? null;

const getArmy = (state: AppState): Nullable<Army> =>
  state.armies.entity?.find(
    (army) => army.id === state.armyList.entity?.armyId,
  ) ?? null;

export const armyListSizePresenter = (size: ArmyListSize): string => {
  if (size === ArmyListSize.Standard) {
    return '';
  }

  return `activerecord.attributes.builder.army_list.size.${ArmyListSize[size]}`;
};

export const armyListPresenter = createSelector(
  [getArmyList, getFolder, getArmy],
  (armyList, folder, army): ArmyListView => {
    let size = armyListSizePresenter(
      armyList?.entity?.size ?? ArmyListSize.Standard,
    );

    return {
      id: armyList?.id ?? '',
      size: size,
      name: armyList?.entity?.name ?? '',
      points: armyList?.entity?.points ?? 0,
      max: armyList?.entity?.max ?? 1,
      isUsed: false,
      game: armyList?.entity?.versionGame ?? 'default',
      folder:
        folder != null
          ? ({
              id: folder.id,
              name: folder.name,
              parentId: folder.parentId,
              isShare: folder.isShare,
              parentName: null,
            } satisfies FolderView as FolderView)
          : null,
      army:
        army != null
          ? ({
              logo: army.medium_logo,
              name: army.nameWithSubVersion,
            } satisfies ArmyView as ArmyView)
          : null,
    } satisfies ArmyListView as ArmyListView;
  },
);
